import script from "./ShotsOverTimeGraph.vue?vue&type=script&setup=true&lang=js"
export * from "./ShotsOverTimeGraph.vue?vue&type=script&setup=true&lang=js"

import "./ShotsOverTimeGraph.vue?vue&type=style&index=0&id=fa4dbfde&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-fa4dbfde"]])

export default __exports__